module.exports = __webpack_public_path__ + "static/img/salestrekker.2c9c87c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salestrekker.png
// module id = eEzd
// module chunks = 1